import { types } from "../Types/types";

export const loginReducer = (state =  {}, action) => {
    switch (action.type)
    {
        case types.login:
            return{
                uid : action.payload.uid,
                nombre : action.payload.username
            };
        case types.logout:
            return {};
        default:
            return state;
    }
}